import React from 'react';
import '../../styles/WorkWithUs.css';
const AssetStep = ({ image, title, description, goal }) => {
  return (
    <div className="assetStep fade-in">
      <div className="imageContainer">
        <img src={image} alt={title} className="stepImage" />
        <div className="verticalBar right" />
      </div>
      <div className="stepText">
        <h3>{title}</h3>
        <p className="mainText">{description}</p>
        <p className="goalText"><strong>Goal:</strong> {goal}</p>
      </div>
    </div>
  );
};

  
export default AssetStep;
